import store from '../store'

function initWalkMe(state) {
    try {
        if (!process.env.VUE_APP_WALKME_URL || !process.env.VUE_APP_ADMIN_PORTAL_DOMAIN) {
            console.log('Failed to initialize WalkMe: No WalkMe/UP URL found');
            return;
        }
        if (!state.credentials.user || !state.accountDetails.BillingSystem) {
            console.log('Failed to initialize WalkMe: No accountDetails found');
            return;
        }

        window.wmVariables = {
            userRole: state.credentials.user.userType,
            accountId: state.credentials.accountId,
            userId: state.credentials.user.userId,
            accountStatus: state.accountDetails.AccountStatusObject.Status,
            billingSystem: state.accountDetails.BillingSystem,
            is10DLC: true,
        };

        const walkme = document.createElement('script');
        walkme.type = 'text/javascript';
        walkme.async = true;
        walkme.src = process.env.VUE_APP_WALKME_URL;
        const firstScriptElement = document.getElementsByTagName('script')[0];
        firstScriptElement.parentNode.insertBefore(walkme, firstScriptElement);

        window._walkmeConfig = {
            smartLoad: false,
            cdhiUrl: `https://${process.env.VUE_APP_ADMIN_PORTAL_DOMAIN}/CD/CDhiddenIframe.compress.html`,
        };
        window.walkme_load_in_iframe = true;
    } catch (error) {
        console.error('Failed to initialize WalkMe:', error.message);
    }
}

export default {
    install() {
        let isInitialized = false

        store.subscribe((mutation, state) => {
            if (['SET_CREDENTIALS', 'SET_ACCOUNT_DETAILS'].includes(mutation.type) &&
                !isInitialized && state.credentials.user && state.accountDetails.AccountStatusObject) {
                isInitialized = true

                initWalkMe(state);
            }
        })
    }
}
